import { createSlice } from "@reduxjs/toolkit";
import { getNewsLetters } from "./_newsLetterAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const newsLetterList = createSlice({
  name: "newsLetterList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getNewsLetters.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getNewsLetters.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getNewsLetters.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
